import { useState, useEffect, useRef } from "react";
import { 
  subscribeToBuildings, 
  seedDefaultBuildingIfEmpty,
  addBuilding,
  updateBuilding,
  deleteBuilding
} from "../services/buildingsService";

export function useBuildings() {
  const [buildings, setBuildings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  
  const hasSeededRef = useRef(false);

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToBuildings(async (data, err) => {
        if (err) {
          setError("Failed to load buildings.");
          setLoading(false);
          return;
        }

        if (data.length === 0 && !hasSeededRef.current) {
          hasSeededRef.current = true;
          await seedDefaultBuildingIfEmpty(data);
        } else {
          setBuildings(data);
          setLoading(false);
        }
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize buildings subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, []);

  const handleAddBuilding = async (buildingData) => {
    try {
      setError("");
      return await addBuilding(buildingData);
    } catch (err) {
      console.error("Error adding building:", err);
      setError(err.message || "Failed to add building.");
      throw err;
    }
  };

  const handleUpdateBuilding = async (id, buildingData) => {
    try {
      setError("");
      await updateBuilding(id, buildingData);
    } catch (err) {
      console.error("Error updating building:", err);
      setError(err.message || "Failed to update building.");
      throw err;
    }
  };

  const handleDeleteBuilding = async (id) => {
    try {
      setError("");
      await deleteBuilding(id);
    } catch (err) {
      console.error("Error deleting building:", err);
      setError(err.message || "Failed to delete building.");
      throw err;
    }
  };

  return {
    buildings,
    loading,
    error,
    setError,
    addBuilding: handleAddBuilding,
    updateBuilding: handleUpdateBuilding,
    deleteBuilding: handleDeleteBuilding
  };
}
